import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { colors, Divider } from "@material-ui/core";
import {
    useStylesTF,
    useStylesTD,
    useStylesContainers,
    useStylesHed,
} from "../../../St/comps/UseStyle";
import { useTranslation } from "react-i18next";
import { useStylesLbl } from "../../../St/Reports/UseStyle";

export default function EmployeesSalaryProfment(props) {

    const {
        salaryEmpData,
        onChangeData,
        onChangeSalary,
        params
    } = props;

    const clasTF = useStylesTF();
    const clasTD = useStylesTD();
    const clsConts = useStylesContainers();
    const { t } = useTranslation(["forms", "translation"]);
    let total_salary = (Number(salaryEmpData?.salary_basic) + Number(params?.salary_add) +
        Number(salaryEmpData?.house) + Number(salaryEmpData?.food) + Number(salaryEmpData?.travel) +
         Number(salaryEmpData?.medical) + Number(salaryEmpData?.salary_other))-Number(params.salary_sub);


    const claslbl = useStylesLbl();

    return (
        <Grid container lg={12} md={12}>
            <Grid item container spacing={2} xs={12} >
                <React.Fragment>
                    <Grid item lg={12} md={12} sm={12} xs={12} >
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id={"salary_basic"}
                            label={t("basic-salary")}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            style={{ backgroundColor: colors.blueGrey[50] }}
                            InputProps={{ className: claslbl.clrBlackLblS }}
                            type="number"
                            name={"salary_basic"}
                            value={salaryEmpData?.salary_basic ?? ""}
                            onChange={onChangeData("salary_basic")}
                        />
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} >
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id={"house"}
                            label={t("housing")}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackLblS }}
                            type="text"
                            name={"house"}
                            value={salaryEmpData.house ?? ""}
                            onChange={onChangeData("house")}
                        />
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} >
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id={"food"}
                            label={t("food")}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackLblS }}
                            type="number"
                            name={"food"}
                            value={salaryEmpData?.food ?? ""}
                            onChange={onChangeData("food")}
                        />
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} >
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id={"travel"}
                            label={t("travel")}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackLblS }}
                            type="number"
                            name={"travel"}
                            value={salaryEmpData.travel ?? ""}
                            onChange={onChangeData("travel")}
                        />
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} >
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id={"medical"}
                            label={t("medical-insurance")}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackLblS }}
                            type="text"
                            name={"medical"}
                            value={salaryEmpData.medical ?? ""}
                            onChange={onChangeData("medical")}
                        />
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} >
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id={"medical"}
                            label={t("bonus")}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackLblS }}
                            type="text"
                            name={"salary_add"}
                            value={params.salary_add ?? ""}
                            onChange={onChangeSalary("salary_add")}
                        />
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} >
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id={"medical"}
                            label={t("deductions")}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackLblS }}
                            type="text"
                            name={"salary_add"}
                            value={params.salary_sub ?? ""}
                            onChange={onChangeSalary("salary_sub")}
                        />
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} >
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id={"salary_other"}
                            label={t("other")}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            InputProps={{ className: claslbl.clrBlackLblS }}
                            type="text"
                            name={"salary_other"}
                            value={salaryEmpData.salary_other ?? ""}
                            onChange={onChangeData("salary_other")}
                        />
                    </Grid>


                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Divider style={{ margin: "8px" }} />
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} >
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="salary_prof"
                            label={t("salary-total-to-prove")}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            style={{ backgroundColor: colors.blueGrey[50] }}
                            InputProps={{ className: claslbl.clrBlackLblS, readOnly: true }}
                            type="number"
                            name="salary_prof"
                            value={parseFloat(total_salary).toFixed(2)}
                        />
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} style={{ marginTop: "0.3rem" }}>

                    </Grid>
                </React.Fragment>
            </Grid>
        </Grid>
    );
}
